export function clickOutside(node, callback) {
    const events = ["click"];
    const handleClick = (event) => {
        if (node &&
            !node.contains(event.target) &&
            !event.defaultPrevented) {
            callback(event);
        }
    };
    events.forEach(e => document.addEventListener(e, handleClick, true));
    return {
        destroy() {
            events.forEach(e => document.removeEventListener(e, handleClick, true));
        },
    };
}
//# sourceMappingURL=clickOutside.js.map